import { useEffect, useState } from 'react';

import { getTimeTrackingGroup } from '@shared/time-tracking-groups/endpoints/getTimeTrackingGroup';

type TimeTrackingGroup = App.Domain.TimeTracking.Data.TimeTrackingGroupData;

export function useFetchTimeTrackingGroup(id: number | null) {
  const [timeTrackingGroup, setTimeTrackingGroup] = useState<TimeTrackingGroup | null>(null);

  useEffect(() => {
    if (id) {
      getTimeTrackingGroup({ id }).then((response) => {
        setTimeTrackingGroup(response);
      });
    } else {
      setTimeTrackingGroup(null);
    }
  }, [id]);

  return timeTrackingGroup;
}
